export const delay = (ms: number) => new Promise((resolve, reject) => {
    setTimeout(resolve, ms);
  }).catch((err) => {
    console.error(`Delay error: ${err}`);
  });